import { render, staticRenderFns } from "./Pallet.vue?vue&type=template&id=862dcdd6"
import script from "./Pallet.vue?vue&type=script&lang=js"
export * from "./Pallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports